<template>
  <div>
    <b-container id="assetList">
      <b-row
        class="assetListItem"
        v-for="ass in assets"
        :key="ass.id"
        align-h="between"
        align-v="center"
      >
        <b-col cols="4">
          <h4>{{ ass.name }}</h4>
          <img :src="qrURL(ass.name)" alt="" />
        </b-col>
        <b-col cols="5" align-v="center">
          <b-button @click="showModal(ass.name)" variant="info">
            Update PDF
          </b-button>
          <b-button v-on:click="copyToClipboard(withDomain(assURL(ass.name)))">
            Copy Link
          </b-button>
          <b-button variant="danger" @click="deleteItem(ass.name)">
            Delete
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-modal id="listModalUploader" title="Update Document">
      <uploader-component
        buttonLabel="Update"
        @didSubmit="didSubmitData()"
        :name="name"
        @close="didClose()"
      ></uploader-component>
      <template v-slot:modal-footer="{}"><div></div></template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import UploaderComponent from "./Uploader.vue";

export default {
  name: "AssetList",
  props: {
    assets: Array,
  },
  components: { UploaderComponent },
  methods: {
    didClose: function() {
      console.log("ThIS CLOSED");
    },
    showModal: function(itemName) {
      this.name = itemName;
      this.$bvModal.show("listModalUploader");
    },
    didSubmitData: function() {
      this.$emit("refresh");
    },
    deleteItem: function(assetName) {
      let validateURL =
        "/backend/" + this.$route.query.uid + "/delete?name=" + assetName;
      console.log(validateURL);
      axios
        .post(validateURL)
        .then(() => {
          this.$emit("refresh");
        })
        .catch(() => {
          this.$emit("refresh");
        });
    },
    copyToClipboard: function(stringToCopy) {
      var el = document.createElement("textarea");
      el.value = stringToCopy;
      el.setAttribute("readonly", "");
      el.style = { position: "absolute", left: "-9999px" };
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },
    withDomain: function(someAssetPath) {
      return "https://" + window.location.hostname + someAssetPath;
    },
    qrURL: function(someAssName) {
      var resultString = "/qr/" + someAssName;
      return resultString;
    },
    assURL: function(someAssName) {
      var resultString = "/asset/" + someAssName;
      return resultString;
    },
  },
  data() {
    return {
      loading: false,
      name: undefined,
    };
  },
};
</script>

<style>
.assetListItem {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
